$(function(){
	$('.cabinet-page nav .link').click(function() {
		$(this).toggleClass('active');
		$('.cabinet-page nav ul').toggleClass('opened');
	});
	$('.faq-page .list .item .name').click(function() {
		$(this).toggleClass('active');
		$(this).next('.text').slideToggle();
	});
    $('.minus').click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 1 ? 1 : count;
        $input.val(count);
        $input.change();
        return false;
    });
    $('.plus').click(function () {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
    });
	$('.catalog-page .filter .mob-link').click(function() {
		$(this).toggleClass('active');
		$('.catalog-page .filter').toggleClass('active');
		$('.catalog-page .filter .main-block').toggleClass('opened');
	});
	$('.catalog-page .filter .item .name').click(function() {
		$(this).toggleClass('active');
		$(this).next('.content').slideToggle();
	});
	$('.header .menu-button').click(function() {
		$('body').toggleClass('hidden');
		$('.mobile-menu').toggleClass('opened');
	});
	
	$('.footer .totop').bind("click", function(e){
	  var anchor = $(this);
	  $('html, body').stop().animate({
		 scrollTop: $(anchor.attr('href')).offset().top
	  }, 1000);
	  e.preventDefault();
	});
	
	if ($(window).width() < 576) {
		$('.item-page .photos').slick({
			arrows: false,
			dots: true
		});

		slidesToShow = 1;
	}
	else {
		slidesToShow = 2;
	}
	
	$('.index-page-slider .list').slick({
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		slidesToShow: slidesToShow,
		slidesToScroll: 1,
		lazyLoad: 'progressive',
	});

	$('.index-page-slider').css('visibility', 'visible');

	$('.gallery-page .list').slick({
		dots: true
	});

	$('.load-invisible').removeClass('load-invisible');
});
